module.exports = __webpack_public_path__ + "img/blueCodeSnip.8b40e446.svg";